<div class="rc-dropdown" [id]="htmlId" [class.toggle-mode-hover]="toggleMode === 'hover'">
  <div class="rc-dropdown-main" [class.is-opened]="dropDownOpen" (click)="toggleDropdown()">
    <ng-content select="[main]"></ng-content>
  </div>

  <div class="rc-dropdown-content" [class.is-opened]="dropDownOpen">
    <ng-content select="[dropdown]"></ng-content>
  </div>
</div>
